export default __webpack_public_path__ + "static/media/GAE. RAM MARK.693479b5.pdf";